import * as yup from 'yup';

export const CreateUpdateAnnotationLabelValidationSchema = yup.object().shape({
	name: yup.string().trim().required('Name is required'),
});
